import { render, staticRenderFns } from "./noticeDetailView.vue?vue&type=template&id=4cde3bfc&scoped=true&"
import script from "./noticeDetailView.vue?vue&type=script&lang=js&"
export * from "./noticeDetailView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./noticeDetailView.vue?vue&type=style&index=1&id=4cde3bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde3bfc",
  null
  
)

export default component.exports